import React from 'react'; 
import { RCL } from "../RCL";
import styles from"./FooterVwq.module.scss";

const LogoutFooter = () => {
    
    return (
        <>
            <div className={styles.logoutFoot}>
                <div className={styles.logoutFootContent}>
                    {RCL({ searchKey: "copyrightFooter"})?.toString().replace("{0}", (new Date()).getFullYear().toString())}
                </div>
            </div>
        </>
    )
};

export default LogoutFooter;